import { render } from "./EmailAddressDetailsPreview.vue?vue&type=template&id=60f94ad4&scoped=true&ts=true"
import script from "./EmailAddressDetailsPreview.vue?vue&type=script&lang=ts"
export * from "./EmailAddressDetailsPreview.vue?vue&type=script&lang=ts"

import "./EmailAddressDetailsPreview.vue?vue&type=style&index=0&id=60f94ad4&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f94ad4"]])

export default __exports__